import { OpenFormGridRow } from './OpenFormGrid.js';
import { OpenFormKnowledgeArticleLink } from './OpenFormKnowledgeArticleLink.js';
import type { OpenFormSection } from '../../../generated/api/openFormSection.js';

export const OpenFormSectionLabel = ({ section }: { section: OpenFormSection }) => (
  <OpenFormGridRow>
    <OpenFormGridRow>
      <h3>{section?.label || null}</h3>
    </OpenFormGridRow>
    <OpenFormGridRow className="of-openform__section-label__description">
      {section?.description && <div>{section.description}</div>}
      {section.knowledgeBaseURL && <OpenFormKnowledgeArticleLink knowledgeBaseURL={section.knowledgeBaseURL} />}
    </OpenFormGridRow>
  </OpenFormGridRow>
);
